export enum PrioritiesEnum {
  Unknown = 0,
  Low = 10,
  Medium = 20,
  High = 30,
  Urgent = 40
}
